import { Pagination } from "@mui/material";
import { Cross2Icon, UploadIcon } from "@radix-ui/react-icons";
import { WorkHistoryIcon } from "hugeicons-react";
import { MoreHorizontal } from "lucide-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import {
  AJOUTER_SERVICE_PARTNER,
  CHARGER_LISTE_SERVICE_PARTNER,
  DELETE_SERVICE_PARTNER,
  RECHERCHER_SERVICE_PARTNER,
} from "../../Utils/constant";
import model from "../../assets/model-fichier/model.xlsx";
import { UpdateServicePartner } from "../../components/Forfait/UpdateServicePartner";
import { Loader } from "../../components/Widget/Loader";
import clientAxios from "../../services/axios";
import { store } from "../../services/service";
import { useStoreServicePartner } from "../../store/storeServicePartner";
export const ServicePartner = () => {
  const servicePartner = useStoreServicePartner();
  const [selectItem, setSelectItem] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const [fichier, setFichier] = useState([]);
  const [message, setMessage] = useState("");

  const handleChangeFichier = (e) => {
    console.log(e.target.files);
    const selectedFiles = e.target.files;
    const newFiles = Array.from(selectedFiles);
    setFichier((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const submit = (data) => {
    setIsSubmit(true);
    store(AJOUTER_SERVICE_PARTNER, "application/json", data)
      .then((res) => {
        setIsSubmit(false);
        if (res.status === 200) {
          reset();
          document.getElementById("fermer_create_role").click();
          toast.success("Créer avec succès");
          servicePartner.getData(
            `${RECHERCHER_SERVICE_PARTNER}?page=0&param=&size=10`
          );
        }
      })
      .catch((err) => {
        document.getElementById("fermer_create_role").click();
        setIsSubmit(false);
        toast.error(err.response.data.donnee);
      });
  };
  useEffect(() => {
    servicePartner.getData(
      `${RECHERCHER_SERVICE_PARTNER}?page=0&param=&size=10`
    );
  }, []);

  const more = (page) => {
    servicePartner.getData(
      `${RECHERCHER_SERVICE_PARTNER}?page=${page - 1}&param=&size=10`
    );
  };

  return (
    <>
      <div>
        <div className="mt-4 lg:flex item-center ">
          {/* <h1 className="text-2xl font-extrabold text-black">Type d'équipements</h1> */}
          <input
            onChange={(e) => {
              servicePartner.getData(
                `${RECHERCHER_SERVICE_PARTNER}?page=0&param=${e.target.value}&size=10`
              );
            }}
            type="text"
            placeholder="Rechercher element..."
            className="input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
          />
          <div className="ml-auto flex items-center">
            <dialog id="upload" className="modal rounded-none">
              <div className="modal-box w-10/12 max-w-xl">
                <div className="modal-action">
                  <h1 className="font-mtn mr-auto text-2xl font-bold">
                    Charger un fichier
                  </h1>
                  <form method="dialog">
                    <button id="close_upload" className="btn btn-sm">
                      <Cross2Icon />
                    </button>
                  </form>
                </div>
                <div>
                  <p className="text-xs text-red-600">{message}</p>
                  <label className="form-contro w-full">
                    <div className="label flex flex-col justify-start items-start gap-1.5">
                      <span className="label-text  font-medium text-gray-400"></span>
                      <div className="w-full">
                        <div className="text-black py-8 border-dashed border bg-gray-50 border-gray-300 px-3 my-2 w-full rounded-md shadow-sm ">
                          <div className="flex justify-center mb-3">
                            <UploadIcon />
                          </div>

                          <p className="text-center text-sm">
                            {fichier.length !== 0 ? "" : "Charger le fichier"}
                          </p>
                          <div className="flex justify-center">
                            <input
                              className="text-sm mx-auto file-input-bordered mb-3 file-input file-input-ghost w-full max-w-xs"
                              type="file"
                              id="fichier"
                              onChange={handleChangeFichier}
                              accept=".xlsx,.csv"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </label>
                  <a
                    href={model}
                    download="modelServicePartner"
                    className="btn text-white bg-black btn-sm mx-1"
                  >
                    Telecharger le model
                  </a>
                  <button
                    onClick={() => {
                      setIsSubmit(true);
                      store(
                        CHARGER_LISTE_SERVICE_PARTNER,
                        "multipart/form-data",
                        {
                          fichier: fichier[0],
                        }
                      )
                        .then((res) => {
                          if (res.status === 200) {
                            setIsSubmit(null);
                            document.getElementById("close_upload").click();
                            servicePartner.getData(
                              `${RECHERCHER_SERVICE_PARTNER}?page=0&param=&size=10`
                            );
                            toast.success("Fichier chargé avec succès");
                          }
                        })
                        .catch((err) => {
                          setIsSubmit(false);
                          setMessage(err?.response?.data?.donnee);
                        });
                    }}
                    disabled={
                      isSubmit ? true : fichier.length === 0 ? true : false
                    }
                    className="font-mtn bg-main btn btn-sm"
                  >
                    charger le fichier
                  </button>
                </div>
              </div>
            </dialog>
            <button
              onClick={() => document.getElementById("upload").showModal()}
              className="btn btn-sm ml-auto  bg-black text-white"
            >
              <UploadIcon /> Charger par lot
            </button>
            <button
              onClick={() => document.getElementById("add").showModal()}
              className="btn btn-sm bg-main rounded-md text-black text-xs hover:bg-gray-900 hover:text-white"
            >
              Ajouter un service partner
            </button>
            <dialog id="add" className="modal ">
              <div className="modal-box ">
                <div className="modal-action">
                  <h1 className="mr-auto text-2xl font-bold">
                    Ajouter un service partner
                  </h1>
                  <form method="dialog">
                    <button
                      id="fermer_create_role"
                      className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                    >
                      ✕
                    </button>
                  </form>
                </div>
                <form onSubmit={handleSubmit(submit)} className="px-2">
                  <div className="my-4 space-y-4">
                    <div className="my-2">
                      <label htmlFor="" className="text-sm font-medium">
                        Designation <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder=""
                        className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                        {...register("designation", { required: true })}
                      />
                      {errors.designation && (
                        <span className="text-sm text-rose-600">
                          Ce champs est obligatoire
                        </span>
                      )}
                    </div>

                    <button
                      type="submit"
                      disabled={isSubmit}
                      className={`${
                        !isSubmit
                          ? "text-black bg-main"
                          : "text-slate-800 bg-slate-200 "
                      } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
                    >
                      {!isSubmit ? "Enregistrer" : "Veuillez patientez..."}{" "}
                      {isSubmit ? (
                        <span className="loading loading-dots loading-xs"></span>
                      ) : null}
                    </button>
                  </div>
                </form>
              </div>
            </dialog>
          </div>
        </div>
        <dialog id="upadate" className="modal ">
          <div className="modal-box ">
            <div className="modal-action">
              <h1 className="mr-auto text-2xl font-bold">Modification</h1>
              <form method="dialog">
                <button
                  id="fermer"
                  className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                >
                  ✕
                </button>
              </form>
            </div>
            <UpdateServicePartner item={selectItem} />
          </div>
        </dialog>
        <div className="grid md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-5 gap-2 my-8">
          {servicePartner?.data?.donnee?.data?.length === 0 ? (
            "Aucune donnée"
          ) : servicePartner?.data?.donnee?.data?.length !== 0 &&
            !servicePartner?.loading ? (
            servicePartner?.data?.donnee?.data?.map((item) => (
              <div className="relative flex gap-1 items-center cursor-pointer text-black shadow-sm border bg-white  rounded text-xs">
                <div className="dropdown dropdown-end absolute right-2 top-2">
                  <div
                    tabIndex={0}
                    role="button"
                    className="w-4 h-4 rounded-full flex items-center justify-center bg-gray-50"
                  >
                    <MoreHorizontal size={20} />
                  </div>
                  <ul
                    tabIndex={0}
                    className="mt-1 dropdown-content z-[1] menu p-2 border shadow bg-base-100 rounded-lg w-44"
                  >
                    <button
                      className="bg-white hover:bg-gray-100 text-gray-600 font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                      onClick={() => {
                        setSelectItem(item);
                        document.getElementById("upadate").showModal();
                      }}
                    >
                      Modifier
                    </button>
                    <button
                      onClick={() => {
                        setSelectItem(item);
                        document.getElementById("delete").showModal();
                      }}
                      className="bg-white hover:bg-red-600 text-black hover:text-white font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                    >
                      Supprimer
                    </button>
                  </ul>
                </div>
                <div className="bg-gray-100 w-10 h-10 rounded m-1 flex items-center justify-center">
                  <WorkHistoryIcon />
                </div>
                <div>
                  <p className="truncate w-36">{item?.designation}</p>
                  {/* <p className='truncate  w-28'>{item?.description}</p> */}
                </div>
              </div>
            ))
          ) : (
            <Loader />
          )}
        </div>
        <div className="my-3 flex justify-end">
          <Pagination
            onChange={(event, newValue) => more(newValue)}
            onSelect={(selectedPage) => more(selectedPage)}
            count={servicePartner.data?.donnee?.totalPages}
            variant="outlined"
            color="primary"
            shape="rounded"
          />
        </div>
        <dialog id="delete" className="modal">
          <div className="modal-box max-w-md rounded-lg">
            <h3 className="font-extrabold text-xl text-red-600 ">Attention</h3>
            <p className="pt-2 text-black font-medium">
              Voulez vous vraiment effectuer cette action ?
            </p>
            <div className="modal-action">
              <form
                method="dialog"
                className="w-full flex items-center justify-end gap-x-4"
              >
                <button className="bg-gray-100 text-gray-600 w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                  Annuler
                </button>
                <button
                  onClick={() => {
                    setIsDeleting(true);
                    clientAxios
                      .delete(`${DELETE_SERVICE_PARTNER}/${selectItem.id}`)
                      .then(() => {
                        servicePartner.getData(
                          `${RECHERCHER_SERVICE_PARTNER}?page=0&param=&size=10`
                        );
                        toast.success("Service partner supprimé");
                      })
                      .catch((err) => {
                        toast.error(
                          err?.response?.data?.donnee ||
                            "Erreur lors de la suppression"
                        );
                      })
                      .finally(() => {
                        setIsDeleting(false);
                        const dlg = document.getElementById("delete");
                        if (dlg) dlg.close();
                      });
                  }}
                  disabled={isDeleting}
                  className={`w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold ${
                    isDeleting
                      ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                      : "bg-red-600 text-white"
                  }`}
                >
                  {isDeleting ? (
                    <div className="h-4 w-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  ) : null}
                  <span className="ml-2">
                    {isDeleting ? "Suppression..." : "Supprimer"}
                  </span>
                </button>
              </form>
            </div>
          </div>
        </dialog>
      </div>
    </>
  );
};
